import { classifyRequestError } from '@shared/utils/classifyRequestError';

import { reportClientError } from './reportClientError';

const IGNORED_MESSAGES = ['ResizeObserver loop', 'Script error.'];

const isIgnored = (message: string | undefined): boolean =>
  !message || IGNORED_MESSAGES.some((ignored) => message.includes(ignored));

export const handleWindowError = (event: ErrorEvent): void => {
  if (!event.error || isIgnored(event.message)) return;
  void reportClientError({
    source: 'boundary',
    kind: 'client',
    message: event.message,
    stack: event.error instanceof Error ? event.error.stack : undefined,
    context: { origin: 'window.onerror', filename: event.filename, line: event.lineno, column: event.colno },
  });
};

export const handleUnhandledRejection = (event: PromiseRejectionEvent): void => {
  const classified = classifyRequestError(event.reason);
  const message = classified.message ?? (event.reason instanceof Error ? event.reason.message : String(event.reason));
  if (isIgnored(message)) return;
  void reportClientError({
    source: classified.kind === 'client' ? 'boundary' : 'request',
    kind: classified.kind,
    code: classified.code,
    httpStatus: classified.status,
    axiosCode: classified.axiosCode,
    method: classified.method,
    url: classified.url,
    correlationId: classified.correlationId,
    message,
    stack: event.reason instanceof Error ? event.reason.stack : undefined,
    context: { origin: 'unhandledrejection' },
  });
};

let installed = false;

export const installGlobalErrorHandlers = (): void => {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  window.addEventListener('error', handleWindowError);
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
};
